/* Shared add feedback. Shopify renders totals with the current account/VAT gates. */
(function () {
  'use strict';
  var busy = false, uncertain = false;
  function notice(box, text, link) {
    var node = box.querySelector('[data-row-notice], [data-add-notice]');
    node.style.color = '';
    node.replaceChildren(document.createTextNode(text));
    if (link) {
      var anchor = document.createElement('a');
      anchor.href = box.dataset.cartUrl; anchor.textContent = 'View basket';
      node.appendChild(document.createTextNode(' ')); node.appendChild(anchor);
    }
    node.setAttribute('role', 'status'); node.hidden = !text;
  }
  async function refresh(cartUrl) {
    var headerUrl = new URL(cartUrl, window.location.origin);
    headerUrl.searchParams.set('section_id', 'header');
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) headerUrl.searchParams.set('preview_theme_id', preview);
    var options = { credentials: 'same-origin', cache: 'no-store' };
    var responses = await Promise.all([
      fetch(cartUrl + '.js', options).then(async function (response) {
        if (!response.ok) throw new Error('Basket refresh failed');
        var cart = await response.json();
        if (!Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error('Basket refresh failed');
        return cart;
      }),
      fetch(headerUrl.pathname + headerUrl.search, options).then(async function (response) {
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }).catch(function () { return null; })
    ]);
    var cart = responses[0], header = responses[1];
    ['[data-basket-summary]', '[data-basket-account]'].forEach(function (selector) {
      var fresh = header && header.querySelector(selector);
      document.querySelectorAll(selector).forEach(function (node) {
        if (fresh) node.innerHTML = fresh.innerHTML;
        // Never leave a stale total, or calculate a trade/consumer price here.
        else node.textContent = 'View basket (' + cart.item_count + ')';
      });
    });
    document.dispatchEvent(new CustomEvent('hci:cart-updated', { detail: cart }));
    return cart;
  }
  window.HciCartFeedback = {
    begin: function (box) {
      if (uncertain) { notice(box, 'Check your basket, then refresh this page before adding more.', true); return false; }
      if (busy) return false;
      busy = true; return true;
    },
    end: function () { busy = false; },
    unknown: function () { uncertain = true; },
    notice: notice,
    refresh: refresh,
    added: function (box, quantity) {
      notice(box, quantity + (quantity === 1 ? ' item added to your basket.' : ' items added to your basket.'), true);
      box.querySelector('[data-row-notice], [data-add-notice]').style.color = 'var(--good, #16734a)';
    }
  };
}());
